import styled from 'styled-components';

export const Wrapper = styled.div`
    margin-bottom: 12px;
`;

export const Item = styled.div`
    margin-bottom: 4px;
`;

export const Action = styled.div``;
